/** TOMIS endpoint, set by environment variables */
export const TOMIS_API_URL = import.meta.env.VITE_TOMIS_API_URL;
